import { FLATS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";

export const FlatService = {
  getAll: (params: IPagination) => requests.get(`${FLATS_URL}`, params),
  create: (params: FormData) => requests.post(`${FLATS_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${FLATS_URL}/${id}`),
  update: (params: FormData, id: number) =>
    requests.put(`${FLATS_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${FLATS_URL}/${id}`),
  deleteFile: (id: number) => requests.delete(`${FLATS_URL}/file/${id}`),
};
